// betslip 推送
import { isBetBuilderSelection } from '@ms/stores/betslip/func'
import customPush from 'custom-push'

// 订阅/取消订阅 betslip selection
export const subSelection = (selection = {}, isSub = true, callback = null, type = 2) => {
  if (isBetBuilderSelection(selection)) {
    selection.betBuilderSelections.forEach((x) => {
      customPush.pushTopic(
        {
          type,
          sportId: x.sportId,
          categoryId: x.categoryId,
          tournamentId: x.tournamentId,
          eventId: x.eventId,
          specifiers: x.marketInfo.specifiers,
          marketIds: x.marketInfo.id
        },
        callback,
        isSub
      )
    })
  } else {
    const { sportId, eventId, categoryId, tournamentId, marketInfo } = selection
    const marketId = marketInfo.id
    const specifiers = marketInfo.specifiers

    customPush.pushTopic(
      {
        type,
        sportId,
        categoryId,
        tournamentId,
        eventId,
        specifiers,
        marketIds: marketId
      },
      callback,
      isSub
    )
  }
}
